module.exports = __webpack_public_path__ + "img/appBack1.43b154bb.png";